/* eslint-disable new-cap */
export function useBrowserTimezone(): string {
  return Intl.DateTimeFormat().resolvedOptions().timeZone;
}
